import { render, staticRenderFns } from "./linearCard.vue?vue&type=template&id=0bb79c43&scoped=true&"
import script from "./linearCard.vue?vue&type=script&lang=js&"
export * from "./linearCard.vue?vue&type=script&lang=js&"
import style0 from "./linearCard.vue?vue&type=style&index=0&id=0bb79c43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb79c43",
  null
  
)

export default component.exports